// import { Helmet } from "react-helmet";
import RandingStyle16 from "../../randing/RandingStyle16";

function Randing054({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle16
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/054/25010301.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/054/25010302.gif`}
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/nextStepButton2.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton2.png`}
      qContainer1Path={`${process.env.REACT_APP_CDN_BASE}/images/054/25010303.png`}
      qContainer2Path={`${process.env.REACT_APP_CDN_BASE}/images/054/25010304.jpg`}
      qOptionImgPath={`${process.env.REACT_APP_CDN_BASE}/images/054/btns`}
      qOptions={["벌어진 앞니", "튀어나온 앞니", "비틀어진 앞니", "토끼 이빨"]}
      optionsArray="twobytwo"
      companyName="광교365리움치과병원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/gwanggyo.jpg`}
      carrotTag={true}
    />
  );
}

export default Randing054;
